import React, { Component } from 'react';
import { Icon } from '@trlogic/ui-pack';

class ListDraggableItem extends Component<Props> {
  render() {
    const { currentModal, ...rest } = this.props;
    return (
      <div
        className={'absolute bottom-0 right-0 hidden items-center gap-x-2 h-10 w-40 border px-2 py-2 opacity-50 border-f-black-5 rounded-[4px] bg-white'}
        id={'list-animate'}
      >
        {currentModal && (
          <>
            <span className={'w-6 h-6 bg-primary flex items-center justify-center text-white rounded-full'}>
              {<Icon size={16} icon={this.props?.itemType?.toLowerCase()} />}
            </span>
            <p>{this.props.currentModal?.model?.value?.payload?.name}</p>
          </>
        )}
      </div>
    );
  }
}

interface Props {
  currentModal: any;
  itemType?: any;
}

export default ListDraggableItem;
